<div class="a-fx-col a-fx-gap-24">
    <div class="h3">
        {{ 'settings.customer-subscription.pricing-examples' | translate }}
    </div>

    <p>
        {{ 'settings.customer-subscription.pricing-examples-review' | translate }}
    </p>

    <nz-tabset>
        <nz-tab [nzTitle]="tabMultipleTitle">
            <ng-template #tabMultipleTitle>
                <ng-container
                    adsptHeap="subscription-plan-example-multiple"
                    [useParent]="true"
                    [elementPath]="{ parent: '.ant-tabs-tab' }"
                >
                    {{ 'settings.customer-subscription.multiple-platforms' | translate }}
                </ng-container>
            </ng-template>
            <div class="a-fx a-color-primary">
                <ng-container
                    *ngTemplateOutlet="
                        platformsTmpl;
                        context: {
                            title: 'settings.customer-subscription.billing-in-august' | translate,
                            accountOneValue: 4000 | currency: currency : 'symbol' : '1.0-2',
                            accountTwoValue:
                                (4000 | currency: currency : 'symbol' : '1.0-2') +
                                ' + ' +
                                (4000 | currency: currency : 'symbol' : '1.0-2'),
                            invoiceTotal: 498 | currency: currency : 'symbol' : '1.0-2',
                            finalPrice:
                                (149 | currency: currency : 'symbol' : '1.0-2') +
                                ' + ' +
                                (349 | currency: currency : 'symbol' : '1.0-2') +
                                ' = ' +
                                (498 | currency: currency : 'symbol' : '1.0-2'),
                            thresholdExceeded: false,
                        }
                    "
                ></ng-container>

                <div class="pricing-divider a-bg-color-border"></div>

                <ng-container
                    *ngTemplateOutlet="
                        platformsTmpl;
                        context: {
                            title: 'settings.customer-subscription.billing-in-september' | translate,
                            accountOneValue: 4000 | currency: currency : 'symbol' : '1.0-2',
                            accountTwoValue:
                                (4000 | currency: currency : 'symbol' : '1.0-2') +
                                ' + ' +
                                (5000 | currency: currency : 'symbol' : '1.0-2'),
                            invoiceTotal: 534 | currency: currency : 'symbol' : '1.0-2',
                            finalPrice:
                                (149 | currency: currency : 'symbol' : '1.0-2') +
                                ' + ' +
                                (11000 | currency: currency : 'symbol' : '1.0-2') +
                                ' x 3.5% = ' +
                                (534 | currency: currency : 'symbol' : '1.0-2'),
                            thresholdExceeded: true,
                        }
                    "
                ></ng-container>
            </div>
        </nz-tab>

        <nz-tab [nzTitle]="tabSingleTitle">
            <ng-template #tabSingleTitle>
                <ng-container
                    adsptHeap="subscription-plan-example-single"
                    [useParent]="true"
                    [elementPath]="{ parent: '.ant-tabs-tab' }"
                >
                    {{ 'settings.customer-subscription.single-platform' | translate }}
                </ng-container>
            </ng-template>
            <div class="a-fx a-color-primary">
                <ng-container
                    *ngTemplateOutlet="
                        platformsTmpl;
                        context: {
                            title: 'settings.customer-subscription.billing-in-august' | translate,
                            accountOneValue: 4000 | currency: currency : 'symbol' : '1.0-2',
                            invoiceTotal: 99 | currency: currency : 'symbol' : '1.0-2',
                            finalPrice: 99 | currency: currency : 'symbol' : '1.0-2',
                            thresholdExceeded: false,
                        }
                    "
                ></ng-container>

                <div class="pricing-divider a-bg-color-border"></div>

                <ng-container
                    *ngTemplateOutlet="
                        platformsTmpl;
                        context: {
                            title: 'settings.customer-subscription.billing-in-september' | translate,
                            accountOneValue: 6500 | currency: currency : 'symbol' : '1.0-2',
                            invoiceTotal: 113.75 | currency: currency : 'symbol' : '1.0-2',
                            finalPrice:
                                (6500 | currency: currency : 'symbol' : '1.0-2') +
                                ' x 1.75% = ' +
                                (113.75 | currency: currency : 'symbol' : '1.0-2'),
                            thresholdExceeded: true,
                        }
                    "
                ></ng-container>
            </div>
        </nz-tab>
    </nz-tabset>
</div>

<ng-template
    let-title="title"
    let-accountOneValue="accountOneValue"
    let-accountTwoValue="accountTwoValue"
    let-invoiceTotal="invoiceTotal"
    let-finalPrice="finalPrice"
    let-thresholdExceeded="thresholdExceeded"
    #platformsTmpl
>
    <div class="a-fx-col a-fx-gap-16" [ngSwitch]="!!accountTwoValue">
        <div class="h4">
            {{ title }}
        </div>

        <div class="a-fx-col a-fx-gap-8">
            <div class="a-fx a-fx-between-start a-fx-gap-48 a-text-cap2">
                <div class="a-fx-col a-fx-gap-8">
                    <strong *ngSwitchCase="true">
                        {{ 'settings.customer-subscription.2-ebay-ads-accounts' | translate }}
                    </strong>

                    <strong *ngSwitchCase="false">
                        {{ 'settings.customer-subscription.2-amazon-ads-accounts' | translate }}
                    </strong>

                    <span class="a-color-secondary">
                        {{ 'settings.customer-subscription.aggregated-monthly-sales' | translate }}
                    </span>
                </div>

                <p class="a-text-bold">
                    {{ accountOneValue }}
                </p>
            </div>

            <div *ngSwitchCase="true" class="a-fx a-fx-between-start a-fx-gap-48 a-text-cap2">
                <div class="a-fx-col a-fx-gap-8">
                    <strong>
                        {{ 'settings.customer-subscription.1-google-2-microsoft-accounts' | translate }}
                    </strong>

                    <span class="a-color-secondary">
                        {{ 'settings.customer-subscription.aggregated-monthly-ad-spend' | translate }}
                    </span>
                </div>

                <p class="a-text-bold">{{ accountTwoValue }}</p>
            </div>
        </div>

        <nz-divider></nz-divider>

        <div class="a-fx a-fx-between-center a-text-cap2">
            <strong>
                {{ 'settings.customer-subscription.invoice-total' | translate }}
            </strong>

            <p class="a-text-bold">{{ invoiceTotal }}</p>
        </div>

        <div class="a-fx-col a-fx-gap-8 a-text-cap1">
            <div class="pricing-calculation a-fx-col a-fx-center-center a-fx-gap-16 a-text-align-center">
                <div class="a-color-secondary">
                    <ng-container *ngIf="!!accountTwoValue || thresholdExceeded; else finalPriceTmpl">
                        {{ 'settings.customer-subscription.final-price-calculation' | translate }}
                    </ng-container>

                    <ng-template #finalPriceTmpl>
                        {{ 'settings.customer-subscription.final-price' | translate }}
                    </ng-template>
                </div>

                <p class="a-text-bold">
                    {{ finalPrice }}
                </p>

                <div class="pricing-threshold">
                    <div
                        *ngIf="!thresholdExceeded"
                        class="a-color-secondary"
                        [innerHTML]="'settings.customer-subscription.within-threshold' | translate"
                    ></div>

                    <ng-container *ngIf="thresholdExceeded">
                        <div
                            *ngIf="!!accountTwoValue"
                            class="a-color-secondary"
                            [innerHTML]="
                                'settings.customer-subscription.exceeded-group-threshold'
                                    | translate
                                        : {
                                              threshold: 10000 | currency: currency : 'symbol' : '1.0-2',
                                              ceiling: 100000 | currency: currency : 'symbol' : '1.0-2',
                                          }
                            "
                        ></div>

                        <div
                            *ngIf="!accountTwoValue"
                            class="a-color-secondary"
                            [innerHTML]="
                                'settings.customer-subscription.exceeded-attributed-threshold'
                                    | translate
                                        : {
                                              threshold: 6000 | currency: currency : 'symbol' : '1.0-2',
                                              ceiling: 90000 | currency: currency : 'symbol' : '1.0-2',
                                          }
                            "
                        ></div>
                    </ng-container>
                </div>
            </div>

            <div class="a-color-secondary">
                {{ 'settings.customer-subscription.no-tax' | translate }}
            </div>
        </div>
    </div>
</ng-template>

<ng-container
    adsptHeap="subscription-plan-examples-close"
    [useParent]="true"
    [debounceResolve]="true"
    [elementPath]="{ parent: '.ant-modal-content', child: '.ant-modal-footer .ant-btn-primary' }"
/>
